import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-ngx-loading-spinner',
  templateUrl: './ngx-loading-spinner.component.html',
  styleUrls: ['./ngx-loading-spinner.component.css']
})
export class NgxLoadingSpinnerComponent implements OnInit, OnChanges {

  @Input() showLoadingSpinner: boolean;

  public loading = false;

  constructor(private readonly spiner: NgxSpinnerService) { }

  ngOnInit(): void {
    if (this.showLoadingSpinner === true) {
      this.spiner.show();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    // Add '${implements OnChanges}' to the class.
    setTimeout(() => {
      for (const propName in changes) {
        if (propName === 'showLoadingSpinner') {
          const change = changes[propName];
          const curVal = JSON.stringify(change.currentValue);
          if (curVal === 'true') {
            this.spiner.show();
          } else {
            this.spiner.hide();
          }
        }
      }
    }, 0);
  }

}
